import React from 'react';

import { GrowthAllocationType } from '@ndvr/portfolio-api';

export const getStrategyDescription = (growthAllocationType: GrowthAllocationType): React.ReactNode => {
    switch (growthAllocationType) {
        case GrowthAllocationType.US_DIRECT_STOCKS:
            return (
                <div className="space-y-4 text-sm">
                    <p>
                        Personalized Indexing at NDVR starts from the NDVR 1500 (the top 1,500 U.S. stocks by market
                        cap), and constructs a fully customized equity portfolio using direct security ownership. This
                        approach maintains broad market exposure while enabling factor tilts, smarter tax management,
                        and personal preference screens.
                    </p>
                    <div>
                        <h4 className="mb-2 font-semibold">Why It&apos;s Powerful</h4>
                        <ul className="ml-4 list-disc space-y-2">
                            <li>
                                <strong>Factor Tilting:</strong> Precisely tilt toward Quality, Value, Momentum, Low
                                Volatility factors, something index ETFs can&apos;t do without drifting from the
                                benchmark. Personalized Indexing lets you shape how your equity exposure behaves while
                                keeping market-like risk.
                            </li>
                            <li>
                                <strong>Tax-Loss Harvesting Opportunities (TLH):</strong> Because the investor directly
                                owns individual stocks, the portfolio can harvest losses at the security level - far
                                more frequently and effectively than any index fund or ETF. This improves after-tax
                                returns and enhances long-term compounding.
                            </li>
                            <li>
                                <strong>Custom Preferences & Screens:</strong> Exclude specific companies, apply
                                ethical/ESG filters, add thematic preferences, or incorporate conviction views - all
                                without abandoning broad diversification.
                            </li>
                            <li>
                                <strong>Broad and Liquid Universe (NDVR 1500):</strong> Anchored in the top ~1,500 U.S.
                                stocks, providing:
                                <ul className="ml-4 list-disc">
                                    <li>deep diversification</li>
                                    <li>high liquidity</li>
                                    <li>enough granularity to express factors and screens cleanly</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Transparent, Direct Ownership:</strong> See and control exactly what you own -
                                with per-stock weights, tax lots, and exposures fully visible.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-2 font-semibold">Ideal For</h4>
                        <p>
                            Investors seeking broad U.S. equity exposure with the added benefits of factor control,
                            superior TLH efficiency, and personalization that traditional ETFs simply cannot match.
                        </p>
                    </div>
                </div>
            );
        default:
            return undefined;
    }
};
